module.exports = __webpack_public_path__ + "static/media/Arrow_DownWords.833c7a80.svg";